import React from "react";
import { useLang } from "@/contexts/LanguageContext";

const IMG = "https://images.unsplash.com/photo-1560264280-88b68371db39?auto=format&fit=crop&q=80";
const tagline = (lang) => (lang === "es"
  ? "Convierte cada conversación en un cliente satisfecho."
  : "Turn every conversation into a happy customer.");

export const AuthHeroMobile = () => {
  const { lang } = useLang();
  return (
    <div className="lg:hidden -mx-8 -mt-8 mb-6 h-40 relative overflow-hidden">
      <img src={`${IMG}&w=1200`} alt="Contact Center Santo Domingo Motors" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20" />
      <div className="absolute bottom-4 left-6 right-6 text-white">
        <h2 className="font-heading text-lg font-extrabold tracking-[-0.03em] leading-tight text-white">{tagline(lang)}</h2>
      </div>
    </div>
  );
};

export const AuthHeroDesktop = () => {
  const { lang } = useLang();
  return (
    <div className="hidden lg:block relative overflow-hidden">
      <img src={`${IMG}&w=1600`} alt="Contact Center Santo Domingo Motors" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
      <div className="absolute bottom-10 left-10 right-10 text-white">
        <h2 className="font-heading text-4xl xl:text-5xl font-extrabold tracking-[-0.035em] leading-[1.02] max-w-2xl text-white">
          {tagline(lang)}
        </h2>
      </div>
    </div>
  );
};
